module.exports = __webpack_public_path__ + "img/avatar_default.b14b4dba.png";